var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "my-2", attrs: { flat: "" } },
    [
      _c(
        "v-card-title",
        { staticClass: "px-2 py-2 ecdgray--text subtitle-3 text-uppercase" },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "", align: "center" } },
            [
              _c("v-col", { attrs: { cols: "6" } }, [
                _vm._v(_vm._s(_vm.$t("Sales")))
              ]),
              _c(
                "v-col",
                {
                  staticClass: "text-none text-end body-2",
                  attrs: { cols: "6" }
                },
                [_c("stats-filter")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            {
              staticClass: "py-4",
              attrs: { align: "center", justify: "center" }
            },
            [
              _c(
                "v-col",
                { staticClass: "text-center", attrs: { cols: "12" } },
                [
                  _c("h1", { staticClass: "sum black--text" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("currency")(
                          _vm.stats.regularTransactionsAmount,
                          "ILS"
                        )
                      )
                    )
                  ]),
                  _c("p", { staticClass: "undertext pt-4" }, [
                    _vm._v(
                      _vm._s(
                        _vm
                          .$t("@TransactionsCount")
                          .replace("@count", _vm.stats.regularTransactionsCount)
                      )
                    )
                  ])
                ]
              ),
              _c("v-col", { attrs: { cols: "12" } }, [_c("v-divider")], 1),
              _c(
                "v-col",
                { staticClass: "text-center mt-4", attrs: { cols: "12" } },
                [
                  _c("h1", { staticClass: "sum error--text text--darken-1" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("currency")(
                          _vm.stats.refundTransactionsAmount,
                          "ILS"
                        )
                      )
                    )
                  ]),
                  _c("p", { staticClass: "undertext pt-4" }, [
                    _vm._v(
                      _vm._s(
                        _vm
                          .$t("@RefundsCount")
                          .replace("@count", _vm.stats.refundTransactionsCount)
                      )
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }